import { InjectionToken } from '@angular/core';

export type AuthSessionCleanup = () => void;

export const AUTH_SESSION_CLEANUP = new InjectionToken<readonly AuthSessionCleanup[]>(
  'AUTH_SESSION_CLEANUP',
);
